<template>
  <div class="stl_02">
		<div class="stl_03">
			<img src="./images/bg_font.jpg" alt="" style="position:absolute; width:50.75em; height:72.75em">
		</div>
		<div class="stl_view">
			<div class="stl_05 stl_06">
				<div class="stl_01" style="top: 30.3084em; left:10.7871em">
					<span id="name">{{$route.query.username}}</span>
				</div>
				<div class="stl_01" style="top: 33.6418em; left:10.7871em">
					<span id="age">{{$route.query.grade}}</span>
				</div>
				<div class="stl_01" style="top: 30.3084em; left:32em">
					<span id="score">{{$route.query.score}}</span>
				</div>
				<div class="stl_01" style="top: 33.6418em; left:32em">
					<span id="number">{{$route.query.examNo}}</span>
				</div>
				<div class="stl_01" style="top: 49.7704em; left:7.4567em"><span class="stl_15 stl_08 stl_09" id="spell">{{$route.query.spell}}</span></div>
				<div class="stl_01" style="top: 49.7704em; left:15.9775em"><span class="stl_15 stl_08 stl_09" id="talk">{{$route.query.dialogSpeak}}</span></div>
				<div class="stl_01" style="top: 49.7704em; left:24.3477em"><span class="stl_15 stl_08 stl_09" id="word">{{$route.query.wordSpeak}}</span></div>
				<div class="stl_01" style="top: 49.7704em; left:32.7022em"><span class="stl_15 stl_08 stl_09" id="apply">{{$route.query.comprehension}}</span></div>
				<div class="stl_01" style="top: 49.7704em; left:41.2807em"><span class="stl_15 stl_08 stl_09" id="nosubtitle">{{$route.query.speakUnaided}}</span></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  mounted () {
  },
  filters: {
  },
  methods: {
  }
}
</script>


<style>
  html,body{
    font-size: unset!important;
    margin: 1px!important
  }
  @page {
    size: A4 portrait;
    margin: 0cm 0cm;
    padding: 0cm 0cm;
  }
	sup {
		top: -0.4em;
		vertical-align: baseline;
		position: relative;
	}
	sub {
		top: 0.4em;
		vertical-align: baseline;
		position: relative;
	}
	.stl_01 {
		position: absolute;
		white-space: nowrap;
    text-align: center;
	}
	.stl_02 {
		height: 72.75em;
		font-size: 1em;
		margin: 0em;
		line-height: 0.0em;
		display: block;
		border-style: none;
		width: 50.75em;
	}
	.stl_03 {
		position: relative;
	}
	.stl_04 {
		left: 0em;
		position: absolute;
		top: 0em;
	}
	.stl_05 {
		position: relative;
		width: 50.75em;
	}
	.stl_06 {
		height: 7.275em;
	}
	@font-face {
		font-family:"LEDWAM+PingFang-SC-Medium";
		src:url("./font/a748bce8-0000-0000-0000-000000000000.ttf");
	}
	.stl_07 {
		font-size: 5.026692em;
		font-family: "LEDWAM+PingFang-SC-Medium", "Times New Roman";
		color: #E53A42;
	}
	.stl_08 {
		line-height: 1.4em;
	}
	.stl_09 {
		letter-spacing: 0em;
	}

	.ie .stl_09 {
		letter-spacing: 0px;
	}
	@font-face {
		font-family:"ILPDIO+PingFang-SC-Medium";
		src:url("./font/58118227-0000-0000-0000-000000000000.ttf");
	}
	.stl_10 {
		font-size: 5.026692em;
		font-family: "ILPDIO+PingFang-SC-Medium", "Times New Roman";
		color: #0677BF;
	}
	@font-face {
		font-family:"UIBQQW+PingFang-SC-Light";
		src:url("./font/a266fb74-0000-0000-0000-000000000000.ttf");
	}
	.stl_11 {
		font-size: 3.156225em;
		font-family: "UIBQQW+PingFang-SC-Light";
		color: #221E1F;
	}
	@font-face {
		font-family:"MPMLNS+PingFang-SC-Regular";
		src:url("./font/d5693385-0000-0000-0000-000000000000.ttf");
	}
	.stl_12 {
		font-size: 1.069817em;
		font-family: "MPMLNS+PingFang-SC-Regular";
		color: #565759;
	}
	.stl_13 {
		font-size: 1.333333em;
		font-family: "UIBQQW+PingFang-SC-Light";
		color: #221E1F;
	}
	.stl_14 {
		font-size: 2.024533em;
		font-family: "UIBQQW+PingFang-SC-Light";
		color: #221E1F;
	}
	.stl_15 {
		font-size: 1.75em;
		font-family: "LEDWAM+PingFang-SC-Medium", "Times New Roman";
		color: #FFFFFF;
	}
	.stl_16 {
		font-size: 1em;
		font-family: "ILPDIO+PingFang-SC-Medium", "Times New Roman";
		color: #FFFFFF;
	}
	#name, #age, #score, #number {
		color: #221e1f;
		font-size: 1.333333em;
		font-weight: 300;
		letter-spacing: 0;
		line-height: 1.4em;
		white-space: normal;
		font-family: "UIBQQW+PingFang-SC-Light";
	}
</style>



// WEBPACK FOOTER //
// src/components/english-certificate/talent-show.vue